export default __webpack_public_path__ + "static/media/juice-fruit-product-r-desktop@3x.4351faa3.png";